import { computed, action, makeObservable } from 'mobx'

interface JSONProviderConfig {
  json: string
}
export default class JsonProvider {
  config: JSONProviderConfig

  constructor (config: JSONProviderConfig) {
    makeObservable(this, {
      data: computed,
      query: action
    })

    this.config = config
  }

  get data () {
    try {
      return JSON.parse(this.config.json)
    } catch (e) {}
  }

  query = context => {
    return Promise.resolve()
  }
}
